enum RemotionRenderIntent {
  GENERATE_THUMBNAIL = 'GENERATE_THUMBNAIL'
}

export const useRemotionEnvVariables = () => {
  const isGeneratingThumbnail =
    typeof process.env.INTENT === 'string' && process.env.INTENT === RemotionRenderIntent.GENERATE_THUMBNAIL;

  const burnFrameNumberInRenderOutput =
    typeof process.env.BURN_FRAME_NUMBER_IN_RENDER_OUTPUT === 'string' &&
    process.env.BURN_FRAME_NUMBER_IN_RENDER_OUTPUT === 'true';

  const useHideSpeakerLabels =
    typeof process.env.USE_HIDE_SPEAKER_LABELS === 'string' && process.env.USE_HIDE_SPEAKER_LABELS === 'true';

  return {
    isGeneratingThumbnail,
    burnFrameNumberInRenderOutput,
    useHideSpeakerLabels
  };
};
